import React from "react";
import { PageContainer, PageContent, PageHeaders } from "../../components/Layout";
import Form from "./Form";

const AppNew = () => {
  const action = ["create"];

  return (
    <PageContainer>
      <PageHeaders title="Хэрэглэгч бүртгэл" />
      <PageContent>
        <Form action={action} />
      </PageContent>
    </PageContainer>
  );
};

export default AppNew;